import type { TOC } from '@ember/component/template-only';

import BoardBoardOrLoopPreviewComponent from 'webapp/components/board/board-or-loop-preview';
import type BoardsLoopsLoopController from 'webapp/controllers/boards/loops/loop';

interface Args {
	controller: BoardsLoopsLoopController;
}

const BoardsLoopsLoopRouteTemplate: TOC<Args> = <template>
	<div id="datawall">
		<BoardBoardOrLoopPreviewComponent
			@loop={{@controller.model}}
			@previewMap={{@controller.previewMap}}
			@showBottomSlider={{@controller.showBottomSlider}}
			@initialBoardId={{@controller.initialBoardId}}
			@updatePreviewMap={{@controller.updatePreviewMap}}
			@onVisibleBoardChange={{@controller.updateBoardIdParam}}
		/>
	</div>
</template>;

export default BoardsLoopsLoopRouteTemplate;
